import { Injectable } from '@angular/core';

declare var clevertap;

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor() { }

  eventAPI(eventName, data) {
    // console.table(eventName, data);
    clevertap.event.push(eventName, data);
  }

  loginEvent(data) {
    clevertap.onUserLogin.push({
      'Site': {
        'Name': data.name,
        'FirstName': data.firstName,
        'LastName': data.lastName,
        'Customer ID': data._id,
        'Email': data.email,
        'Country': data.countryCode ? data.countryCode : null,
        'Phone No.': data.phone,
        'Gender': data.gender == 'male' ? 'M' : 'F',
        'Account Creation': data.created,
        'User Group': data.userGroup,
        'Customer type 1': data.userType,
        'Dummy User': data.isDummyUser,
        'Password Reset Required': data.isPasswordResetRequired
      }
    });
   this.loginEventCapture(data);
  }

  loginEventCapture(data) {
    let obj =  {
      'Customer ID': data._id,
      'Email': data.email,
      'Password Reset Required': data.isPasswordResetRequired,
      'Source': 'IPJ'
    };
    this.eventAPI('Login', obj);
  }

  confirmProfileEvent(data) {
    data = {
      'Name': data.name,
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Customer ID': data._id,
      'Email': data.email,
      'Country': data.countryCode ? data.countryCode : null,
      'Phone No.': data.phone,
      'Gender': data.gender == 'male' ? 'M' : 'F',
      'Account Creation': data.created,
      'User Group': data.userGroup,
      'Customer Type 1': data.userType,
      'Dummy User': data.isDummyUser,
      'Password Reset Required': data.isPasswordResetRequired
    }
    this.eventAPI('Confirm Profile', data);
  }

  forgotPasswordEvent(data) {
    let obj = {
      'Customer ID': data._id,
      'Email': data.email
    };
    this.eventAPI('Forgot Password', obj);
  }

  // startProgramEvent(data) {
  //   let obj = {
  //     'Customer ID': data.user._id,
  //     'Password Reset Required': data.user.isPasswordResetRequired,
  //     'First Block': data.currentCardName ? data.currentCardName : '',
  //     'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
  //   };
  //   this.eventAPI('Start Program', obj);
  // }

  resumeProgramEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Current Block': data.currentCardName ? data.currentCardName : '',
      'Progress': Math.round(data.activationData.progress) + '%',
      'Block Number': data.currentBlockNumber ? data.currentBlockNumber : null
    };
    this.eventAPI('Resume Program', obj);
  }

  startPreTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Block Number': data.item.order ? data.item.order : null,
      'Questions': data.item.exercise && data.item.exercise.pages && data.item.exercise.pages.length && data.item.exercise.pages[0].elements && data.item.exercise.pages[0].elements.length ? data.item.exercise.pages[0].elements.length : null,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Pre-Test Title': data.item.exercise && data.item.exercise.title ? data.item.exercise.title : ''
    };
    this.eventAPI('Start Pre-Test', obj);
  }

  resumePreTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Block Number': data.item.order ? data.item.order : null,
      'Questions': data.item.exercise && data.item.exercise.pages && data.item.exercise.pages.length && data.item.exercise.pages[0].elements && data.item.exercise.pages[0].elements.length ? data.item.exercise.pages[0].elements.length : null,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Pre-Test Title': data.item.exercise && data.item.exercise.title ? data.item.exercise.title : '',
      'Progress': Math.round(data.item.status.progress ? data.item.status.progress : 0) + "%"
    };
    this.eventAPI('Resume Pre-Test', obj);
  }

  viewFeedbackPreTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Block Number': data.item.order ? data.item.order : null,
      'Questions': data.item.exercise && data.item.exercise.pages && data.item.exercise.pages.length && data.item.exercise.pages[0].elements && data.item.exercise.pages[0].elements.length ? data.item.exercise.pages[0].elements.length : null,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Pre-Test Title': data.item.exercise && data.item.exercise.title ? data.item.exercise.title : '',
      'Progress': Math.round(data.item.status.progress ? data.item.status.progress : 0) + "%"
    };
    this.eventAPI('View Pre-Test Feedback', obj);
  }

  submitPreTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Questions': data.exerciseLength,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Pre-Test Title': data.exerciseData.title ? data.exerciseData.title : '',
      'Block Number': data.blockItem && data.blockItem.order ? data.blockItem.order : null
    };
    this.eventAPI('Complete Pre-Test', obj);
  }

  startPostTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Block Number': data.item.order ? data.item.order : null,
      'Questions': data.item.exercise && data.item.exercise.pages && data.item.exercise.pages.length && data.item.exercise.pages[0].elements && data.item.exercise.pages[0].elements.length ? data.item.exercise.pages[0].elements.length : null,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Post-Test Title': data.item.exercise && data.item.exercise.title ? data.item.exercise.title : ''
    };
    this.eventAPI('Start Post-Test', obj);
  }

  resumePostTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Block Number': data.item.order ? data.item.order : null,
      'Questions': data.item.exercise && data.item.exercise.pages && data.item.exercise.pages.length && data.item.exercise.pages[0].elements && data.item.exercise.pages[0].elements.length ? data.item.exercise.pages[0].elements.length : null,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Post-Test Title': data.item.exercise && data.item.exercise.title ? data.item.exercise.title : ''
    };
    this.eventAPI('Resume Post-Test', obj);
  }

  submitPostTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Questions': data.exerciseLength,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Post-Test Title': data.exerciseData.title ? data.exerciseData.title : '',
      'Block Number': data.blockItem && data.blockItem.order ? data.blockItem.order : null,
      'Duration': data.exerciseData.duration
    };
    this.eventAPI('Complete Post-Test', obj);
  }

  viewFeedbackPostTestEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Email': data.user.email,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Block Number': data.item.order ? data.item.order : null,
      'Questions': data.item.exercise && data.item.exercise.pages && data.item.exercise.pages.length && data.item.exercise.pages[0].elements && data.item.exercise.pages[0].elements.length ? data.item.exercise.pages[0].elements.length : null,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Post-Test Title': data.item.exercise && data.item.exercise.title ? data.item.exercise.title : ''
    };
    this.eventAPI('View Post-Test Feedback', obj);
  }

  logoutEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
    };
    this.eventAPI('Logout', obj);
  }

  habitDrillMenuEvent(data) {
    let obj = {
      "Customer ID": data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : ''
    };
    this.eventAPI('View Habit-drills (Menu)', obj);
  }

  programFeedbackEvent(data) {
   let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Rating': data.feedback.rating
    };
    this.eventAPI('Program Feedback', obj);
  }
  viewCertificateTranscriptEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Score': data.activationData.programPercentage ? data.activationData.programPercentage : 0
    };
    this.eventAPI('View Certificate & Transcript', obj);
  }

  // ---------- Event paused by product team -------------- //

  // completeProgramEvent(data) {
  //   let obj = {
  //     'Customer ID': data.user._id,
  //     'Password Reset Required': data.user.isPasswordResetRequired,
  //     'Activation Unique Name':  data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
  //     'Score': data.activationData && data.activationData.programPercentage ? data.activationData.programPercentage : 0
  //   };
  //   this.eventAPI('Complete Program', obj);
  // }

  viewCertificateEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
    };
    this.eventAPI('View Certificate', obj);
  }

  startReflectiveExerciseEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.course.templateName ? data.course.templateName : '',
      'Module Title': data.currItem.moduleName ? data.currItem.moduleName : '',
      'Exercise Template': data.exerciseData.templateName ? data.exerciseData.templateName : ''
    };
    this.eventAPI('Start Reflective Exercise', obj);
  }

  completeReflectiveExerciseEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.course.templateName ? data.course.templateName : '',
      'Module Title': data.currItem.moduleName ? data.currItem.moduleName : '',
      'Exercise Template': data.exerciseData.templateName ? data.exerciseData.templateName : ''
    };
    this.eventAPI('Complete Reflective Exercise', obj);
  }

  startTouchstoneEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.course.templateName ? data.course.templateName : ''
    };
    this.eventAPI('Start Touchstone', obj);
  }

  // ---------- Event paused by product team -------------- //

  // completeTouchstoneEvent(data) {
  //   let obj = {
  //     'Customer ID': data.user._id,
  //     'Password Reset Required': data.user.isPasswordResetRequired,
  //     'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
  //     'Course Template': data.course.templateName ? data.course.templateName : '',
  //     'Score': `${data.score}%`
  //   }
  //   this.eventAPI('Complete Touchstone', obj);
  // }

  viewCourseCompletionEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.course.templateName ? data.course.templateName : '',
      'Current Progress': data.course.progress ? data.course.progress : null
    };
    this.eventAPI('View Course Completion', obj);
  }

  startCourseEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Course Template': data.course.courseTemplate,
      'Activation Unique Name': data.program && data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName: '',
      'Block Number': data.course.order
    };
    this.eventAPI('Start Course', obj);
  }

  resumeCourseEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Course Template': data.course.courseTemplate,
      'Current Progress': data.course.status && data.course.status.progress ? data.course.status.progress : 0,
      'Block Number': data.course.order ? data.course.order : 0
    };
    this.eventAPI('Resume Course', obj);
  }

  reviseCourseEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Course Template': data.course.courseTemplate,
      'Current Progress': data.course.status && data.course.status.progress ? data.course.status.progress : 0,
      'Block Number':  data.course.order ? data.course.order : 0,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
    };
    this.eventAPI('Revise Course', obj);
  }

  // ---------- Event paused by product team -------------- //

  // completeCourseEvent(data) {
  //   let obj = {
  //     'Customer ID': data.user._id,
  //     'Password Reset Required': data.user.isPasswordResetRequired,
  //     'Course Template': data.courseObj && data.courseObj.courseTemplate ? data.courseObj.courseTemplate : '',
  //     'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
  //     'Block Number': data.courseObj && data.courseObj.order ? data.courseObj.order : null
  //   };
  //   this.eventAPI('Complete Course', obj);
  // }

  courseFeedbackEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Course Template': data.course.templateName,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Rating': data.feedback.feedback && data.feedback.feedback.rating ? data.feedback.feedback.rating : null
    };
    this.eventAPI('Course Feedback', obj);
  }

  viewCourseProgressEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Course Template': data.courseObj && data.courseObj.courseTemplate ? data.courseObj.courseTemplate : null,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Block Number': data.courseObj && data.courseObj.order ? data.courseObj.order : null,
      'Current Progress': data.courseObj && data.courseObj.status && data.courseObj.status.progress ? data.courseObj.status.progress : null
    };
    this.eventAPI('View Course Progress', obj);
  }

  attendMasterclassEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Block Number': data.masterclassObj && data.masterclassObj.order ? data.masterclassObj.order : null,
      'Masterclass Title': data.masterclassObj && data.masterclassObj.title ? data.masterclassObj.title : '' ,
      'Faculty': data.masterclassObj && data.masterclassObj.masterClassObjects && data.masterclassObj.masterClassObjects.length && data.masterclassObj.masterClassObjects[0].faculty && data.masterclassObj.masterClassObjects[0].faculty.name ? data.masterclassObj.masterClassObjects[0].faculty.name : ''
    };
    this.eventAPI('Attend Masterclass', obj);
  }

  watchMasterclassVideoEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Block Number': data.masterclassObj && data.masterclassObj.order ? data.masterclassObj.order : null,
      'Masterclass Title': data.masterclassObj && data.masterclassObj.title ? data.masterclassObj.title : '',
    }
    this.eventAPI('Watch Masterclass Video', obj);
  }

  watchProgramIntroEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name':  data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : ''
    };
    this.eventAPI('Watch Prog Intro (Play Button)', obj);
  }

  stopProgramIntroEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
    };
    this.eventAPI('Stop Prog Intro', obj);
  }

  watchCourseIntroEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.program.activation && data.program.activation.uniqueName ? data.program.activation.uniqueName : '',
      'Block Number': data.courseObj && data.courseObj.order ? data.courseObj.order : null ,
      'Course Template': data.courseObj && data.courseObj.courseTemplate ? data.courseObj.courseTemplate : ''
    };
    this.eventAPI('Watch Course Intro', obj);
  }

  stopCourseIntroEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': (data.program && data.program.activation && data.program.activation.uniqueName) ? data.program.activation.uniqueName : '',
      'Block Number': data.courseObj && data.courseObj.order ? data.courseObj.order : null,
      'Course Template': data.courseObj && data.courseObj.courseTemplate ? data.courseObj.courseTemplate : ''
    };
    this.eventAPI('Stop Course Intro', obj);
  }

  clickReportErrorEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.courseTemplate,
      'Module Title': data.course.moduleName ? data.course.moduleName : null,
      'Nugget Title': data.course.title ? data.course.title : null
    };
    this.eventAPI('Click Report Error', obj);
  }

  submitReportErrorEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Module Title': data.course.moduleTitle ? data.course.moduleTitle : '',
      'Nugget Title': data.course.videoName ? data.course.videoName: '',
      'Error Type': data.eType,
      'Details': data.details ? 'Added' : 'Not Added'
    };
    this.eventAPI('Submit Report Error', obj);
  }

  adjustPlayerMenuEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Action': data.action ? 'Expand' : 'Collapse'
    };
    this.eventAPI('Adjust Player Menu', obj);
  }

  seeMasterclassDetailsEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name':  data.prog.activation && data.prog.activation.uniqueName ? data.prog.activation.uniqueName : '',
      'Masterclass Title': data.masterclass.title,
    };
    this.eventAPI('See Masterclass Details', obj);
  }

  clickNextEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Source': data.source ? data.source : '',
      // 'Course Template': data.source && data.source.templateName ? data.source.templateName : '',
      // "Next block": ''
    }
    this.eventAPI("Click 'Next'", obj);
  }

  watchProgCompletionEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.prog.activation && data.prog.activation.uniqueName ? data.prog.activation.uniqueName : '',
      // 'Completion': completion,
      // 'Stop timestamp': WatchedDuration,
    };
    this.eventAPI('Watch Prog Completion', obj);
  }

  habitDrillBeginEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Template Name': data.courseObj.courseTemplate,
      'Habit Drill': data.courseObj.courseHabitDrills && data.courseObj.courseHabitDrills.length && data.courseObj.courseHabitDrills[0].courseHabitDrillTemplateName ? data.courseObj.courseHabitDrills[0].courseHabitDrillTemplateName : ''
    };
    this.eventAPI('Attempt Habit-drill (Start Activity)', obj);
  }

  habitDrillThriveSkillsEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Template Name': data.course.templateName ? data.course.templateName : ''
    };
    this.eventAPI('Know Thrive Skills', obj);
  }

  viewProfileEvent(data) {
    let obj =  {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : ''
    };
    this.eventAPI('View Profile (Menu)', obj);
  }

  saveUserProfileEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'FirstName': data.user.firstName,
      'LastName': data.user.lastName,
      'Phone No.': data.user.phone,
      'Updated Name': ((data.userPrevData.firstName != data.user.firstName) || (data.userPrevData.lastName != data.user.lastName)) ? 'Yes' : 'No',
      'Updated Phone No.': (data.userPrevData.phone != data.user.phone) ? 'Yes' : 'No',
      'Timezone' : data.user.timeZone,
      'Updated Timezone': (data.userPrevData.timeZone != data.user.timeZone) ? 'Yes' : 'No',
    }
    this.eventAPI('Save Profile', obj);
  }

  viewFaqEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
    };
    this.eventAPI('View FAQ', obj);
  }

  habitDrillListEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Template Name': data.item.courseTemplateName ? data.item.courseTemplateName : '',
      'Habit Drill': data.item.templateName ? data.item.templateName : ''
    };
    this.eventAPI('Attempt Habit-drill (list)', obj);
  }

  habitDrillTaggedEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Template Name': data.item.courseTemplate,
      'Habit Drill': data.habit && data.habit.courseHabitDrillTemplateName ? data.habit.courseHabitDrillTemplateName : ''
    };
    this.eventAPI('Attempt Habit-drill (Tagged)', obj);
  }

  markHabitDrillCompleteEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Template Name': data.templateName,
      'Habit Drill': data.habitDrill
    };
    this.eventAPI('Mark Habit-Drill Complete', obj);

  }

  habitDrillResponseEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Tagged With': data.habitDrill.templateName,
      'Habit Drill': data.habitDrill.userResponse && data.habitDrill.userResponse.templateName ? data.habitDrill.userResponse.templateName : ''
    }
    this.eventAPI('See Habit-Drill Response', obj);
  }

  submitHabitDrillEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Tagged With': data.habitData.courseName ? data.habitData.courseName: '',
      'Submission': data.submission,
      'Habit Drill': data.habitDrill && data.habitDrill.courseHabitDrillTemplateName ? data.habitDrill.courseHabitDrillTemplateName : '',
      'Rating': data.rating
    };
    this.eventAPI('Submit Habit-Drill', obj);
  }

  habitDrillPracticeEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Tagged with': data.habitDrill.courseName,
      'Habit Drill': data.habitDrill.templateName ? data.habitDrill.templateName : '',
      'Submission': data.habitDrill.userResponse && data.habitDrill.userResponse.feedback && data.habitDrill.userResponse.feedback.text ? 'Yes' : 'No',
      'Rating': data.habitDrill.userResponse && data.habitDrill.userResponse.feedback && data.habitDrill.userResponse.feedback.rating ? data.habitDrill.userResponse.feedback.rating : null
    };
    this.eventAPI('Practice Habit-drill', obj);
  }

  strideSubmitEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.course.templateName,
      'Nugget Title': data.video.title,
      // 'Stride Description':strideDescription,
      'Stride Type': data.question.type,
      // 'Score': data.matches[0] ? data.matches[0] : 0
    };
    this.eventAPI('Submit Stride', obj);
  }

  strideSkipEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.course.templateName,
      'Nugget Title': data.video.title,
      // 'Stride Description':strideDescription,
      'Stride Type': data.question.type,
      // 'Score': data.matches[0] ? data.matches[0] : 0
    };
    this.eventAPI('Skip Stride', obj);
  }

  downloadTranscriptEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Score': data.activationData.programPercentage ? data.activationData.programPercentage : 0,
    };
    this.eventAPI('Download Transcript', obj);
  }

  copyCertificateLinkEvent(data) {
    let obj = {
      'Customer ID': data.activationData.userId,
      'Email': data.certificate.email,
      'Password Reset Required': false,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : ''
    };
    this.eventAPI('Copy Certificate Link', obj);
  }

  shareCertificateEvent(data) {
    let obj = {
      'Customer ID': data.activationData.userId,
      'Email': data.certificate.email,
      'Password Reset Required': false,
      'Certificate Id': data.certificate.certificateInfo.certificateId,
      'Program Title': data.certificate.certificateInfo.programTitle,
      'Share Method': data.provider == 'fb' ? 'Facebook' : data.provider,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : ''
    };
    this.eventAPI('Share Certificate', obj);
  }

  playBackCaptionLanguageChangedEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.currCourse.templateName,
      'Module Title': data.currItem.moduleName,
      'Nugget Title': data.currItem.title,
      'Language': data.lang
    };
    this.eventAPI('Play Subtitle', obj);
  }

  playBackSpeedChangedEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.currCourse.templateName,
      'Module Title': data.currItem.moduleName,
      'Nugget Title': data.currItem.title,
      'Speed': data.speed + 'x'
    };
    this.eventAPI('Change Speed', obj);
  }

  startNuggetEvent(data) {
    let obj ={
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.currentUserCourse.templateName,
      'Module Title': data.currItem.moduleName,
      'Nugget Title': data.currItem.title,
      'Duration': data.currItem.duration
    };
    this.eventAPI('Start Nugget', obj);
  }

  resumeNuggetEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.currentUserCourse.templateName,
      'Module Title': data.currItem.moduleName,
      'Nugget Title': data.currItem.title,
      'Duration': data.currItem.duration,
      'Resume Timestamp': data.resumeTimestamp
    };
    this.eventAPI('Resume Nugget', obj);
  }

  completeNuggetEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.currCourse.templateName,
      'Module Title': data.currItem.moduleName,
      'Nugget Title': data.currItem.title,
      'Duration': data.currItem.duration
    };
    this.eventAPI('Complete Nugget', obj);
  }

  startModuleEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Course Template': data.currentUserCourse.templateName,
      'Module Title': data.currItem.moduleName
    };
    this.eventAPI('Start Module', obj);
  }

  viewDashboardEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Program Progress': data.activationData.progress
    };
    this.eventAPI('View Dashboard', obj);
  }

  viewLeaderboardEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Current progress': data.activationData.progress
    };
    this.eventAPI('View Leaderboard', obj);
  }

  notesBookmarksEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
    };
    this.eventAPI('Notes & Bookmarks', obj);
  }

  // Add Bookmark, Remove Bookmark events
  addRemoveBookmarksEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Nugget Title': data.nugget.title ? data.nugget.title : '',
      'Course Template': data.course.templateName ? data.course.templateName : ''
    };
    this.eventAPI(data.eventName, obj);
  }

  // Save Notes, Edit Notes events
  editNotesEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Nugget Title': data.nugget.title ? data.nugget.title : '',
      'Course Template': data.course.templateName ? data.course.templateName : '',
      'Time': data.time ? data.time : 0
    };
    this.eventAPI(data.eventName, obj);
  }

  saveNotesEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Nugget Title': data.nugget ? data.nugget : '',
      'Course Template': data.course.templateName ? data.course.templateName : ''
    };
    this.eventAPI(data.eventName, obj);
  }

  viewBookmarksEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Nugget Title': data.bookmarkData.data[0].title ? data.bookmarkData.data[0].title:'',
      'Course Template': data.bookmarkData.data[0].courseTemplateName ? data.bookmarkData.data[0].courseTemplateName: ''
    };
    this.eventAPI('View Bookmarks', obj);
  }

  viewNotesPlayerEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Nugget Title': data.nugget.title ? data.nugget.title:'',
      'Course Template': data.course.templateName ? data.course.templateName : ''
    };
    this.eventAPI('View Notes (player)', obj);
  }

  downloadResourceEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Course Template': data.course.templateName ? data.course.templateName : '',
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Nugget Title': data.nugget ? data.nugget : ''
    };
    this.eventAPI('Download Resource', obj);
  }

  // Notes tab, Bookmarks tab events
  notesBookmarksTabEvent(data) {
    let obj = {
      'Customer ID': data.user._id,
      'Password Reset Required': data.user.isPasswordResetRequired,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName: '',
    };
    this.eventAPI(data.eventName, obj);
  }

  initalTimezoneChangeEvent(data){
    let obj={
      'Customer ID': data.user._id,
      'Activation Unique Name': data.activationData.program && data.activationData.program.activation && data.activationData.program.activation.uniqueName ? data.activationData.program.activation.uniqueName : '',
      'Timezone' : data.timeZone
    }
    this.eventAPI('Save Timezone', obj);
  }
}
